import { Box, Divider, Typography } from "@mui/material";

import DevicesMakesTable from "../devices/components/DevicesMakesTable";
import CreateSKUDialogContainer from "./components/CreateSKUDialogContainer";
import SKUsTable from "./components/SKUsTable";
import CreateDeviceMakeDialogContainer from "../devices/components/CreateDeviceMakeDialogContainer";

const SKUsPage = (): JSX.Element => {
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">SKU Configurations</Typography>
        <CreateSKUDialogContainer />
      </Box>
      <SKUsTable />

      <Divider sx={{ my: 3 }} />

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">Device Makes</Typography>
        <CreateDeviceMakeDialogContainer />
      </Box>
      <DevicesMakesTable />
    </Box>
  );
};

export default SKUsPage;
